module.exports = Tone;